import React, { Component } from 'react';
import Slider from 'react-slick';

import './style.sass';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

function SampleNextArrow(props) {
    const { onClick } = props;

    return (
        <div className="arrowNext__container">
            <div
                className="arrowPrev-inner__container arrowPrev-inner__container--next"
                onClick={onClick}
            >
                <span className="arrowPrev-inner__span" />
            </div>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { onClick } = props;

    return (
        <div className="arrowPrev__container">
            <div className="arrowPrev-inner__container" onClick={onClick}>
                <span className="arrowPrev-inner__span" />
            </div>
        </div>
    );
}

export default class SliderSkolkovo extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow className={'slider-skolkovo__arrow-next'} />,
            prevArrow: <SamplePrevArrow className={'slider-skolkovo__arrow-prev'} />,
        };

        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <div className="slider-skolkovo">
                    <div className="slider-skolkovo__wrapper">
                        <CommonTitle className="slider-skolkovo__title">
                            Работающие баннеры
                        </CommonTitle>
                        <Slider {...settings}>
                            <div className="slider-skolkovo__item">
                                <div className="slider-skolkovo__img">
                                    <img
                                        src="/images/svg/skolkovo/slider-skolkovo__img1.jpg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                            <div className="slider-skolkovo__item">
                                <div className="slider-skolkovo__img">
                                    <img
                                        src="/images/svg/skolkovo/slider-skolkovo__img2.jpg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                            <div className="slider-skolkovo__item">
                                <div className="slider-skolkovo__img">
                                    <img
                                        src="/images/svg/skolkovo/slider-skolkovo__img3.jpg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}
